import * as Sentry from '@sentry/vue';
import { isNavigationFailure, NavigationFailureType } from 'vue-router';
import type { App } from 'vue';
import type { RouteLocationNormalized } from 'vue-router';

import { sentryKey } from '@/infra/injection-keys';

export { sentryKey };

export type SentryType = typeof Sentry & {
  handleRouting(navigationPromise: Promise<RouteLocationNormalized | void>): Promise<void | RouteLocationNormalized>;
};

export const sentryPlugin = {
  install(app: App, { sentry }: { sentry: typeof Sentry }) {
    async function handleRouting(
      navigationPromise: Promise<RouteLocationNormalized | void>
    ): Promise<void | RouteLocationNormalized> {
      return navigationPromise.catch((err: unknown) => {
        if (!isNavigationFailure(err, NavigationFailureType.redirected)) {
          sentry.captureException(err);
        }
      });
    }

    const sentryWithRouting = {
      ...sentry,
      handleRouting,
    } as SentryType;

    app.provide(sentryKey, sentryWithRouting);
  },
};
